import React from 'react';
import DiscoverGroupsOrClubsPanel from './DiscoverGroupsOrClubsPanel';

/** Groups' counterpart to DiscoverClubsPanel — see DiscoverGroupsOrClubsPanel. */
const DiscoverGroupsPanel: React.FC = () => <DiscoverGroupsOrClubsPanel kind="group" />;

export default DiscoverGroupsPanel;
